/* src/app/shared/components/checkbox/checkbox.component.scss */
/*# sourceMappingURL=checkbox.component.css.map */
